import { CommonModule, DatePipe, Location } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, HostListener, OnInit, ViewChild, ViewEncapsulation, AfterViewInit } from '@angular/core';
import { FormsModule, ReactiveFormsModule, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { Router, RouterModule, Routes } from '@angular/router';
import { AdvancedSettingService, TaskCategoryService, TaskService, TimeconversionService } from '@fitness-force/api';
import { ScheduleType, CalendarView, TaskType, TaskStatus } from '@fitness-force/enum';
import { Appointment, Class, ClassById, ClientInfo, LatestTask, ListTaskCategoryResponse, TENANTSINTERFACE, TaskCategoryResponse, TaskOutcomeDetails, TaskResponse } from '@fitness-force/models';
import { ShortNamePipe } from '@fitness-force/pipes/short-name';
import { Store } from '@ngrx/store';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { AvatarModule } from 'primeng/avatar';
import { BadgeModule } from 'primeng/badge';
import { BreadcrumbModule } from 'primeng/breadcrumb';
import { ButtonModule } from 'primeng/button';
import { DatePickerModule } from 'primeng/datepicker';
import { DialogModule } from 'primeng/dialog';
import { DividerModule } from 'primeng/divider';
import { SelectModule } from 'primeng/select';
import { InputTextModule } from 'primeng/inputtext';
import { MultiSelectModule } from 'primeng/multiselect';
import { StyleClassModule } from 'primeng/styleclass';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { Observable, BehaviorSubject, distinctUntilChanged } from 'rxjs';
import { TENANTS_INFO, STAFF_STATE } from '../../../state/app.state';
import { AuthguardService, CallOutcomeComponent, TaskCreateComponent, TenantResolverService, TourOutcomeComponent } from '@fitness-force/shared';
import { TaskCategoryDropdownComponent } from '@fitness-force/crm';
import { ClientInfoSidebarComponent } from '@fitness-force/core';

// Syncfusion Imports
import {
  ScheduleModule, DayService, WeekService, WorkWeekService, MonthService, AgendaService, 
  TimelineViewsService, TimelineMonthService, ResizeService, DragAndDropService, PrintService, 
  ScheduleComponent, EventSettingsModel, View, GroupModel, ActionEventArgs, CellClickEventArgs, 
  EventClickArgs, TimeScaleModel, EventRenderedArgs
} from '@syncfusion/ej2-angular-schedule';

@Component({
  selector: 'fitness-force-sales-calendar',
  templateUrl: './sales-calendar.component.html',
  styleUrls: ['./sales-calendar.component.css'],
  changeDetection: ChangeDetectionStrategy.Default,
  encapsulation: ViewEncapsulation.None,
  providers: [
    // Syncfusion providers
    DayService, WeekService, WorkWeekService, MonthService, AgendaService,
    TimelineViewsService, TimelineMonthService, ResizeService, DragAndDropService, PrintService,
    DatePipe
  ],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    BreadcrumbModule,
    InputTextModule,
    DividerModule,
    DialogModule,
    BadgeModule,
    DatePickerModule,
    SelectModule,
    ButtonModule,
    AvatarModule,
    StyleClassModule,
    MultiSelectModule,
    ShortNamePipe,
    TourOutcomeComponent,
    CallOutcomeComponent,
    TaskCreateComponent,
    TaskCategoryDropdownComponent,
    ClientInfoSidebarComponent,
    TranslateModule,
    RouterModule,
    ProgressSpinnerModule,
    ScheduleModule
  ]
})
export class SalesCalendarComponent implements OnInit, AfterViewInit {
  @ViewChild('scheduleObj', { static: false })
  public scheduleObj: ScheduleComponent | undefined; // Reference to Syncfusion Schedule

  // Syncfusion specific configuration
  public eventSettings: EventSettingsModel = {
    dataSource: [], // Will be populated with task data
    fields: {
      id: 'id',
      subject: { name: 'Subject' },
      startTime: { name: 'StartTime' },
      endTime: { name: 'EndTime' },
      isAllDay: { name: 'IsAllDay' },
    },
    enableTooltip: true
  };

  public group: GroupModel = {
    resources: [], // Will be set dynamically based on view
    allowGroupEdit: false,
    byDate: false
  };

  public timeScaleOption: TimeScaleModel = {
    enable: true,
    interval: 60, // 1 hour major slots
    slotCount: 2  // 30 min minor slots
  };

  // Loading indicator
  loading = new BehaviorSubject<boolean>(false);

  getAccessTenantList$: Observable<any> | any;
  getAccessedStaffList$ = new BehaviorSubject<any[] | any>([]);
  roomList$ = new BehaviorSubject<any[] | any>([]);

  selectedDateTime: any;
  inlineCalendar: Date | undefined;
  calendarOptions: any;
  calView: any;
  currentView: any;
  currentUrl: any;
  tenantId = 0;
  currentDate: any = new Date();
  trainerResources: any = [];
  isTrainerView: Observable<boolean> | any = false;
  calendarStartDate: any;
  calendarEndDate: any;
  showMeetingOutcomePopup: Observable<boolean> | any = false;
  showCallOutcomePopup: Observable<boolean> | any = false;
  showTaskCreate = false;
  selectedTaskcategory = new Map();
  selectedTaskType = new Map();
  selectedTrainer = new Map();
  calendarEvents$ = new BehaviorSubject<any[]>([]);
  classAppointmentEvents: any[] = [];
  classDetails: ClassById | undefined;

  eventObject: any | undefined;
  appointmentObject: Appointment | undefined;
  classObject: Class | undefined;
  classAdvancedSettings = false;
  classesActive = true;
  appointmentsActive = true;
  CalendarFullScreen = false;

  fitnessCalendarForm!: UntypedFormGroup;
  FiltersForm: UntypedFormGroup;

  calendarResourceView: any[];
  calendarView: any[] = [
    { name: 'Month View', value: 'Month', icon: 'assets/img/icons/icon-month-view.svg' },
    { name: 'Week View', value: 'Week', icon: 'assets/img/icons/icon-week-view.svg' },
    { name: 'Day View', value: 'Day', icon: 'assets/img/icons/icon-day-view.svg' },
    { name: 'Agenda View', value: 'Agenda', icon: 'assets/img/icons/icon-agenda-view.svg' },
  ];
  selectedCalendarView: { name: string; value: string; icon: string };
  selectedCalendarResourceView: { name: string; icon: string; value: string };
  resource: { id: number, name: string, color: string, img: string };
  disableCalendarView = false;

  taskTypes: any = []
  taskTypesCategory!: any;
  tasksParams = new Map();
  allTasks = new BehaviorSubject<TaskResponse[]>([]);
  tourAppointmentDuration:number=30;
  callDuration:number=30;

  outcomeDetail : TaskOutcomeDetails ={} as TaskOutcomeDetails;
  taskCategory$ = new BehaviorSubject<TaskCategoryResponse[]>([]);
  showClientSidebar = false;
  activeClientId = 0;

  constructor(
    private store: Store,
    private router: Router,
    private translate: TranslateService,
    private timeService: TimeconversionService,
    private fb: UntypedFormBuilder,
    public datepipe: DatePipe,
    public location: Location,
    private taskService: TaskService,
    private advanceSettingService: AdvancedSettingService,
    private taskCategoryService: TaskCategoryService,
    public cd: ChangeDetectorRef
  ) {
    this.calendarResourceView = [
      { name: 'Schedule', icon: 'fa fa-user-plus', value: 'schedule' },
      { name: 'Trainer', icon: 'fa fa-user', value: 'trainer' }
    ];
    this.taskTypes = [
      { name: 'Call', value: 'call', icon: 'fa fa-phone' },
      { name: 'Tour', value: 'tour', icon: 'fa fa-map-marker-alt' },
    ];
    
    this.calendarView = [
      { name: 'Month View', value: 'Month', icon: 'assets/img/icons/icon-month-view.svg' },
      { name: 'Week View', value: 'Week', icon: 'assets/img/icons/icon-week-view.svg' },
      { name: 'Day View', value: 'Day', icon: 'assets/img/icons/icon-day-view.svg' },
      { name: 'Agenda View', value: 'Agenda', icon: 'assets/img/icons/icon-agenda-view.svg' },
    ];

    // Will initialize selections in componentInit method
  }

  ngOnInit(): void {
    this.componentInit();
  }

  ngAfterViewInit(): void {
    // Set a small delay to ensure the schedule has fully initialized
    setTimeout(() => {
      if (this.scheduleObj) {
        // Force the view to update based on currentView
        this.scheduleObj.currentView = this.currentView;
      }
    }, 100);
  }

  componentInit() {
    // Get calendar view preferences from localStorage or use defaults
    const localStorageCalVal = localStorage.getItem('SELECTED_CAL_VIEW') as View || 'Week';
    const localStorageCalResVal = localStorage.getItem('SELECTED_RES_VIEW') || '';

    // Set initial view state
    this.currentView = localStorageCalVal;
    this.isTrainerView = localStorageCalResVal === 'trainer';

    // Set selected view in dropdown
    this.selectedCalendarView = this.calendarView.find((c) => {
      return c.value === localStorageCalVal;
    }) || this.calendarView.find(c => c.value === 'Week');

    this.selectedCalendarResourceView = this.calendarResourceView.find((c) => {
      return c.value === localStorageCalResVal;
    }) || this.calendarResourceView[0];

    // Initialize forms
    this.fitnessCalendarForm = this.fb.group({
      calendarView: [localStorageCalVal || 'Week'],
      resourceView: [localStorageCalResVal || 'schedule'],
      calendarViewMob: [this.selectedCalendarView],
      resourceViewMob: [this.selectedCalendarResourceView],
    });

    this.FiltersForm = this.fb.group({
      SelectedTaskType: [''],
      SelectedTaskCategory: [''],
      SelectedStaff: [''],
    });

    // Update group settings based on current view
    this.updateGroupSettings();

    // Get tenant information and initialize data
    this.getAccessTenantList$ = this.store.select(TENANTS_INFO);
    this.getAccessTenantList$.subscribe((tenant: TENANTSINTERFACE) => {
      this.tenantId = tenant.selected_tenant.id;
      if (this.tenantId > 0) {
        this.getTaskCategory();
        this.getSettings();
        this.GetStaffs();

        // Adjust view if using resource views
        if((this.isTrainerView && this.trainerResources.length > 0)) {
          this.currentView = 'TimelineDay';
        }
      }
    });

    // Set up filter change handlers
    this.SelectedTaskCategoryFormControl.valueChanges.pipe(distinctUntilChanged())
    .subscribe((value: any) => {
      if(value) {
        this.selectedTaskcategory.clear();
        value.forEach((c: any) => {
          this.selectedTaskcategory.set(c.id, c);
        });
        this.filterEvents();
      }
    });
  }

  updateGroupSettings(): void {
    if (this.isTrainerView) {
      this.group = {
        resources: ['Trainers'],
        allowGroupEdit: false,
        byDate: false,
        enableCompactView: false
      };
    } else {
      // Reset to no grouping for regular views
      this.group = {
        resources: [],
        allowGroupEdit: false,
        byDate: false
      };
    }
    
    // Manually update group settings if schedule is already created
    if (this.scheduleObj) {
      this.scheduleObj.group = this.group;
    }
  }

  getSettings() {
    const settings = this.advanceSettingService.getAdvanceSettings(this.tenantId);
    if (settings) {
      settings.subscribe({
        next: (res: any) => {
          if (res.items != null) {
            const tourDuration: any = res.items.find((x: { key: string; }) => x.key.toLowerCase() == "default_tour_appt_duration")
            if (tourDuration != null) {
              this.tourAppointmentDuration = Number(tourDuration.value);
            }
            const callDuration: any = res.items.find((x: { key: string; }) => x.key.toLowerCase() == "default_task_call_duration")
            if (callDuration != null) {
              this.callDuration = Number(callDuration.value);
            }
          }
        },
      });
    }
  }

  GetStaffs() {
    this.store.dispatch({ type: 'FETCH_STAFF_LIST' });
    this.store.select(STAFF_STATE).subscribe((data: any) => {
      if (data && data.staffList && data.staffList.length > 0) {
        this.getAccessedStaffList$.next(
          data.staffList.filter((o: any) => {
            return (String(o.status).toLowerCase() == 'active' );
          })
        );
        this.trainerResources = [];
        this.getAccessedStaffList$.value.forEach((o: any) => {
          this.resource = { id: o.id, name: o.name, img: o.ff_picture, color: '' };
          this.trainerResources.push(this.resource);
        });
        this.setTaskTypeAndCategorySelected();
      }
    });
  }

  getTaskCategory(): void {
    this.taskCategoryService
      .getTaskCategory(this.tenantId)
      .subscribe((data: ListTaskCategoryResponse) => {
        const odata = data.items.filter((o: TaskCategoryResponse) => {
          return String(o.status).toLowerCase() == 'active';
        });
        this.taskCategory$.next(odata);
      });
  }

  @HostListener('window:visibilitychange', ['$event'])
  VisibilityChange(event: any): void {
    if (event.target.visibilityState.toLowerCase() == 'visible') {
      this.getAllTask(this.calendarStartDate,this.calendarEndDate);
    }
  }

  getAllTask(startDate: string, endDate: string) {
    this.loading.next(true);
    this.tasksParams.set('due_date_from', { paramName: 'due_date_from', paramValue:startDate })
    this.tasksParams.set('due_date_to', { paramName: 'due_date_to', paramValue: endDate })
    const params = this.getAllParams;
    this.taskService.TaskGetAll(this.tenantId, params).subscribe({
      next: (res: any) => {
        this.allTasks.next(res.items ? res.items as TaskResponse[] : []);
        const events = this.CreateEvents(res.items);
        this.eventSettings = { ...this.eventSettings, dataSource: events };
        this.setTaskTypeAndCategorySelected();
        this.loading.next(false);
        this.cd.detectChanges();
      },
      error: (error: any) => {
        this.allTasks.next([]);
        this.eventSettings = { ...this.eventSettings, dataSource: [] };
        this.loading.next(false);
        this.cd.detectChanges();
      },
    });
  }

  CreateEvents(tasks: TaskResponse[]) {
    if (!tasks) return [];
    
    const events: any[] = [];
    tasks.forEach((task) => {
      if (!task.scheduled_date) return; // Skip invalid dates
      
      const startDate = this.timeService.ConvertUTCToLocalDateTime(task.scheduled_date);
      const endDateTime: Date = new Date(startDate);
      endDateTime.setMinutes(endDateTime.getMinutes() + (this.callDuration || 30));
      
      const cssClass = task.status == TaskStatus.Completed ? 'line-through' : '';
      
      const event: any = {
        id: task.id,
        Guid: task.id.toString(),
        Subject: task.title,
        StartTime: startDate,
        EndTime: endDateTime,
        IsAllDay: false,
        TaskType: task.type,
        Status: task.status,
        OriginalData: task,
        CssClass: cssClass,
        CategoryColor: this.getBackgroundColor(task.type)
      };
      
      // Set ResourceId based on current view
      if (this.isTrainerView && task.assigned_to_staff_id) {
        event.ResourceId = task.assigned_to_staff_id;
      }
      
      events.push(event);
    });
    
    console.log('Created events:', events); // Debug to see the events being created
    return events;
  }

  setTaskTypeAndCategorySelected() {
    this.SelectedTaskCategoryFormControl.setValue(this.taskCategory$.value);
    this.SelectedTaskTypeFormControl.setValue(this.taskTypes);
    this.SelectedStaffFormControl.setValue(this.getAccessedStaffList$.value);
    this.getAccessedStaffList$.value.forEach((o: { id: any; name: any; ff_picture: any; }) => {
      if (this.allTasks.value.find(a => a.assigned_to_staff_id == o.id)) {
        this.resource = { id: o.id, name: o.name, img: o.ff_picture, color: '' };
        this.trainerResources.push(this.resource);
        this.selectedTrainer.set(o.id, o);
      }
    });
  }

  setCalendarView(event: any) {
    this.selectedCalendarView = this.calendarView.find(
      (c) => c.value == event.value.value
    )!;
    this.resourceViewFormControl.setValue(CalendarView.Schedule);
    this.calenderViewFormControl.setValue(this.selectedCalendarView.value);
    this.changeView();
  }

  setCalendarResourceView(event: any) {
    this.selectedCalendarResourceView = this.calendarResourceView.find(
      (c) => c.value.toLowerCase() == event.value.value
    );
    this.resourceViewFormControl.setValue(event.value.value);
    if (this.resourceViewFormControlValue != CalendarView.Schedule)
      this.calenderViewMobFormControl.disable();
    else this.calenderViewMobFormControl.enable();
    this.changeResourceView();
  }

  changeView(): void {
    this.isTrainerView = false;
    if (this.resourceViewFormControl.value != CalendarView.Schedule)
      this.resourceViewFormControl.setValue(CalendarView.Schedule);

    this.resourceViewFormControl.updateValueAndValidity();
    switch (this.calenderViewFormControlValue) {
      case CalendarView.Year:
        this.calView = {
          calendar: { type: CalendarView.Year },
        };
        break;
      case CalendarView.Month:
        this.calView = {
          calendar: { labels: true, type: CalendarView.Month },
        };
        localStorage.setItem('SELECTED_CAL_VIEW', this.calenderViewFormControlValue);
        localStorage.setItem('CALENDER_PREF', JSON.stringify(this.calView));
        break;
      case CalendarView.Week:
        this.calView = {
          schedule: {
            type: CalendarView.Week,
            timeCellStep: 30,
            timeLabelStep: 30,
          },
        };
        localStorage.setItem('SELECTED_CAL_VIEW', this.calenderViewFormControlValue);
        localStorage.setItem('CALENDER_PREF', JSON.stringify(this.calView));
        break;
      case CalendarView.Day:
        this.calView = {
          schedule: {
            type: CalendarView.Day,
            timeLabelStep: 30,
            timeCellStep: 30
          },
        };
        localStorage.setItem('SELECTED_CAL_VIEW', this.calenderViewFormControlValue);
        localStorage.setItem('CALENDER_PREF', JSON.stringify(this.calView));
        break;
      case CalendarView.Agenda:
        this.calView = {
          agenda: { type: CalendarView.Day, scrollable: true },
        };
        localStorage.setItem('SELECTED_CAL_VIEW', this.calenderViewFormControlValue);
        localStorage.setItem('CALENDER_PREF', JSON.stringify(this.calView));
        break;
    }
  }

  changeResourceView() {
    switch (this.resourceViewFormControlValue) {
      case CalendarView.Trainer:
        {
          this.calView = {
            timeline: {
              type: CalendarView.Day,
              timeCellStep: 30,
              timeLabelStep: 30,
            },
          };
          this.isTrainerView = true;
          this.setTrainerResource();
          this.filterEvents();
          this.calenderViewFormControl.setValue(null);
          this.calenderViewMobFormControl.setValue({
            value: '',
            disabled: true,
          });
          this.calenderViewFormControl.updateValueAndValidity();
          localStorage.setItem('SELECTED_RES_VIEW', this.resourceViewFormControlValue);
          localStorage.setItem('CALENDER_PREF', JSON.stringify(this.calView));
        }
        break;
      case CalendarView.Schedule:
        {
          const calendarEvents$ = this.calendarEvents$.value;
          this.calendarEvents$.next(calendarEvents$);
          this.calView = {
            calendar: { labels: true, type: CalendarView.Month },
          };
          this.isTrainerView = false;
          this.calenderViewFormControl.setValue(CalendarView.Month);
          this.calenderViewMobFormControl.setValue(
            this.calendarView.find((c) => c.value == CalendarView.Month)
          );

          this.calenderViewFormControl.updateValueAndValidity();
          this.calenderViewMobFormControl.updateValueAndValidity();
          localStorage.setItem('SELECTED_RES_VIEW', this.resourceViewFormControlValue);
          localStorage.setItem('CALENDER_PREF', JSON.stringify(this.calView));
        }
        break;
    }
  }

  getFirstDayOfWeek(d: Date, prev: boolean): Date {
    const day = d.getDay();
    const diff = d.getDate() - day + (prev ? -7 : 7);
    return new Date(d.setDate(diff));
  }

  getTaskDetails(event: any): TaskResponse {
    return this.allTasks.value.find((c) => c.id == event.id)!;
  }

  GetClassDetailsForAgenda(event: any) {
    return this.allTasks.value.find((c) => c.id == event.id)!;
  }


  SelectClassType(event: any): void {
    this.selectedTaskType.clear();
    event.value.forEach((c: any) => {
      this.selectedTaskType.set(c.value.toLowerCase(), c);
    });
    this.filterEvents();
  }

  SelectTrainer(event: any): void {
    this.selectedTrainer.clear();
    event.value.forEach((c: any) => {
      this.selectedTrainer.set(c.id, c);
    });
    this.filterEvents();
  }

  filterEvents() {
    this.loading.next(true);
    setTimeout(() => {
      let tasks = this.allTasks.value;
      const selectedTrainerIds = [...this.selectedTrainer.keys()];
      const selectedTaskTypes = [...this.selectedTaskType.keys()];
      const selectedTaskCategories = [...this.selectedTaskcategory.keys()];
      
      if (selectedTrainerIds.length > 0) {
        tasks = tasks.filter((task) =>
          selectedTrainerIds.includes(task.assigned_to_staff_id)
        );
      }
      
      if (selectedTaskTypes.length > 0) {
        tasks = tasks.filter((task) =>
          selectedTaskTypes.includes(task.type.toLowerCase())
        );
      }
      
      if (selectedTaskCategories.length > 0) {
        tasks = tasks.filter((task) => {
          return selectedTaskCategories.includes(task.category_id);
        });
      }

      const events = this.CreateEvents(tasks);
      this.eventSettings = { ...this.eventSettings, dataSource: events };
      this.loading.next(false);
    }, 100);
  }

  setTrainerResource() {
    this.trainerResources = [];
    this.getAccessedStaffList$.value.forEach((coach: any) => {
      if (this.selectedTrainer.has(coach.id)) {
        this.resource = { id: coach.id, name: coach.name, img: coach.ff_picture, color: '' };
        this.trainerResources.push(this.resource);
      }
      else {
        this.resource = { id: coach.id, name: coach.name, img: coach.ff_picture, color: '' };
        this.trainerResources.push(this.resource);
      }
    });
  }

  navigatePage(prev: boolean): void {
    const currentDate = this.currentDate;
    if (
      this.calView.agenda ||
      this.calenderViewFormControlValue == CalendarView.Day.toString() ||
      this.resourceViewFormControlValue == CalendarView.Trainer
    ) {
      const prevNextPage = new Date(
        currentDate.setDate(currentDate.getDate() + (prev ? -1 : 1))
      );
      this.currentDate = prevNextPage;
    } else if (
      this.calenderViewFormControlValue == CalendarView.Month.toString()
    ) {
      const prevNextPage = new Date(
        currentDate.getFullYear(),
        currentDate.getMonth() + (prev ? -1 : 1),
        1
      );
      this.currentDate = prevNextPage;
    } else {
      const prevNextSunday = this.getFirstDayOfWeek(currentDate, prev);
      this.currentDate = prevNextSunday;
    }
  }

  printCalendar(): void {
    if (this.scheduleObj) {
      this.scheduleObj.print();
    }
  }

  toggleFullScreen(): void {
    this.CalendarFullScreen = !this.CalendarFullScreen;
    // Refresh layout after changing container size
    setTimeout(() => {
      if (this.scheduleObj) {
        this.scheduleObj.refresh();
      }
    }, 0);
  }

  OnDateChange(date: Date) {
    this.currentDate = date;
  }

  tenentChanged(event: any) {
    window.location.reload();
  }

  GetAppointmentEvent(event: any) {
    if (event.event)
      this.calendarEvents$.next([...this.calendarEvents$.value, event]);
    else
      this.getAllTask(this.calendarStartDate, this.calendarEndDate);
  }

  reloadEvents(event: any) {
    this.getAllTask(this.calendarStartDate, this.calendarEndDate);
  }

  openTaskPopup(event: any) {
    console.log('Opening task popup for event:', event);
    
    if (event.OriginalData) {
      const task = event.OriginalData as TaskResponse;
      if (task.type && task.type.toLowerCase() === 'call') {
        this.outcomeDetail = this.SetOutComeDetails(event);
        this.showCallOutcomePopup = true;
        this.showMeetingOutcomePopup = false;
      } else {
        this.outcomeDetail = this.SetOutComeDetails(event);
        this.showCallOutcomePopup = false;
        this.showMeetingOutcomePopup = true;
      }
    } else {
      console.warn('No original data in event:', event);
    }
  }

  getBackgroundColor(taskType: string) {
    let colorCode: string = "";
    const taskTypeEnum = taskType as keyof typeof TaskType;
    const data = TaskType[taskTypeEnum];
    switch (data) {
      case TaskType.Call:
        colorCode = "cyan"
        break;
      case TaskType.Tour:
        colorCode = "orange"
        break;
      case TaskType.Email:
        colorCode = "indigo"
        break;
      case TaskType.Sms:
        colorCode = "teal"
        break;
    }
    return colorCode;
  }

  getTaskTypeIcon(event: any) {
    let icon: string = "";
    // Handle both direct task objects and event data from Syncfusion
    const task = event.OriginalData || this.allTasks.value.find(t => t.id == event.id);
    
    if (!task) {
      console.warn('Task not found for event:', event);
      return icon;
    }
    
    const taskType = task.type as keyof typeof TaskType;
    const data = TaskType[taskType];
    
    switch (data) {
      case TaskType.Call:
        icon = "fa fa-phone text-xs mr-1"
        break;
      case TaskType.Tour:
        icon = "fa fa-map-marker-alt text-xs xs-1"
        break;
      case TaskType.Email:
        icon = " fa fa-envelope font-light text-xs mr-1"
        break;
      case TaskType.Sms:
        icon = "fa fa-comments font-light text-xs mr-1"
        break;
    }
    return icon;
  }

  isCompleted(task: TaskResponse) {
    return task.status == TaskStatus.Completed || task.status.toString() == TaskStatus[TaskStatus.Completed];
  }

  SetOutComeDetails(event: any): TaskOutcomeDetails {
    // Get task ID from either OriginalData or directly from event
    const taskId = event.OriginalData?.id || event.id;
    
    if (!taskId) {
      console.error('Failed to extract task ID from event:', event);
      return {} as TaskOutcomeDetails;
    }
    
    const taskDetails = this.allTasks.value.find((c) => c.id == taskId);
    
    if (!taskDetails) {
      console.error('Task not found for ID:', taskId);
      return {} as TaskOutcomeDetails;
    }
    
    const outcomedetails: TaskOutcomeDetails = {
      assigned_to_staff_id: taskDetails.assigned_to_staff_id,
      outcome: "",
      expected_closure_date: taskDetails.oppportunity_info ? taskDetails.oppportunity_info.expected_closure_date : '',
      value_in_minor_currency: taskDetails.oppportunity_info ? taskDetails.oppportunity_info.value_in_minor_currency : 0,
      latest_task: {} as LatestTask,
      stage_master_id: taskDetails.oppportunity_info ? taskDetails.oppportunity_info.stage_master_id : 0,
      id: taskDetails.oppportunity_info ? taskDetails.oppportunity_info.id : 0,
      company_id: taskDetails.company_id,
      tenant_id: taskDetails.tenant_id,
      board_type: taskDetails.oppportunity_info ? taskDetails.oppportunity_info.board_type.toString() : '',
      name: taskDetails.oppportunity_info ? taskDetails.oppportunity_info.name : '',
      client_info: {} as ClientInfo,
      service_type: [],
      tour_id: [],
      trial_id: [],
      comments: '',
      hot_warm_cold: taskDetails.oppportunity_info ? taskDetails.oppportunity_info.hot_warm_cold.toString() : '',
      is_fresh: false,
      is_stale: false,
      sort_order: 0,
      lost_reason_type: undefined,
      lost_reason_other: '',
      lost_competitor: '',
      lost_competitor_latitude: '',
      lost_competitor_longitude: '',
      lost_competitor_place_id: '',
      lost_contract_end_date: '',
      lost_expected_price_in_minor_currency: 0,
      lost_missing_facility: [],
      lost_comments: '',
      created_by: 0,
      created_date: '',
      updated_by: 0,
      updated_date: ''
    };
    
    const latestTask: LatestTask = {
      id: taskDetails.id,
      type: taskDetails.type,
      category_id: taskDetails.category_id,
      name_primary_language: taskDetails.name_primary_language,
      name_secondary_language: taskDetails.name_secondary_language,
      priority: taskDetails.priority,
      scheduled_date: taskDetails.scheduled_date.toString(),
      status: taskDetails.status.toString(),
      title: taskDetails.title
    };
    
    outcomedetails.service_type = taskDetails.oppportunity_info ? taskDetails.oppportunity_info.service_type : [];
    outcomedetails.client_info = taskDetails.client_info;
    outcomedetails.latest_task = latestTask;
    
    return outcomedetails;
  }

  HideOutComePopup(event: any) {
    this.showCallOutcomePopup = false;
    this.showMeetingOutcomePopup = false;
    if (event.modified) {
      this.getAllTask(this.calendarStartDate, this.calendarEndDate);
    }
  }

  HideTaskCreate(event: any) {
    this.showTaskCreate = false;
    this.getAllTask(this.calendarStartDate, this.calendarEndDate);
  }
  taskCreated(event: any) {
    this.getAllTask(this.calendarStartDate, this.calendarEndDate);
  }

  getFilteredResource()
  {
    return this.trainerResources ?  this.getDistinctResources(this.trainerResources) :[];
  }

  getDistinctResources(resources: any): [] {
    const resourceSet = new Set<number>();
    return resources.filter((r:any) => {
      if (!resourceSet.has(r.id)) {
        resourceSet.add(r.id);
        return true;
      }
      return false;
    });
  }

  GoToClientDetails(event: any) {
    this.activeClientId = event.clientId;
    this.showClientSidebar = true;
  }

  closeSidebar(event: any) {
    this.showClientSidebar = false;
  }


  get calenderViewFormControl(): UntypedFormControl {
    return this.fitnessCalendarForm.controls.calendarView as UntypedFormControl;
  }

  get calenderViewFormControlValue(): any {
    return this.fitnessCalendarForm.controls.calendarView.value;
  }

  get resourceViewFormControl(): UntypedFormControl {
    return this.fitnessCalendarForm.controls.resourceView as UntypedFormControl;
  }

  get SelectedTaskTypeFormControl(): UntypedFormControl {
    return this.FiltersForm.controls.SelectedTaskType as UntypedFormControl;
  }
  get SelectedTaskCategoryFormControl(): UntypedFormControl {
    return this.FiltersForm.controls.SelectedTaskCategory as UntypedFormControl;
  }
  get SelectedStaffFormControl(): UntypedFormControl {
    return this.FiltersForm.controls.SelectedStaff as UntypedFormControl;
  }

  get resourceViewFormControlValue(): any {
    return this.fitnessCalendarForm.controls.resourceView.value;
  }

  get getCalenderViewEnum() {
    return CalendarView;
  }

  get getScheduleTypeEnum() {
    return ScheduleType;
  }

  get getEvents(): any {
    return [...this.calendarEvents$.value];
  }

  get calenderViewMobFormControl(): UntypedFormControl {
    return this.fitnessCalendarForm.controls
      .calendarViewMob as UntypedFormControl;
  }

  get getAllParams(): Array<any> {
    return [...this.tasksParams.values()];
  }

  // Syncfusion event handlers
  onScheduleCreated(args: any): void {
    console.log('Schedule created');
    
    // Make sure eventSettings is properly initialized
    if (this.eventSettings && this.eventSettings.dataSource) {
      console.log('Event settings initialized with dataSource:', 
        (this.eventSettings.dataSource as any[]).length, 'events');
    } else {
      console.warn('Event settings or dataSource not properly initialized');
    }
    
    // Initial data load when scheduler is created
    this.loadDataForCurrentView();
  }

  onEventRendered(args: EventRenderedArgs): void {
    // Add custom styling to tasks
    if (args.data && args.data.OriginalData) {
      const task = args.data.OriginalData;
      const element = args.element;
      
      // Apply background color based on task type
      const bgColor = this.getBackgroundColor(task.type);
      element.style.backgroundColor = bgColor;
      element.style.borderColor = bgColor;
      element.style.color = 'white';
      element.style.height = 'auto';
      
      // Add CSS classes based on task status
      if (this.isCompleted(task)) {
        element.classList.add('line-through');
      }
      
      // Add task type icon
      const taskTypeIcon = document.createElement('i');
      taskTypeIcon.classList.add(...this.getTaskTypeIcon(task).split(' '));
      taskTypeIcon.style.marginRight = '4px';
      
      // Find the subject element and add the icon before it
      const subjectElement = element.querySelector('.e-subject');
      if (subjectElement && !subjectElement.querySelector('i')) {
        subjectElement.insertBefore(taskTypeIcon, subjectElement.firstChild);
      } else {
        // If no subject element, add icon to the beginning of the event element
        const firstChild = element.firstChild;
        if (firstChild && !element.querySelector('i')) {
          element.insertBefore(taskTypeIcon, firstChild);
        }
      }
    }
  }

  onActionBegin(args: ActionEventArgs): void {
    // Handle toolbar interactions for header customization
  }

  onActionComplete(args: ActionEventArgs): void {
    // Load data when view or date range changes
    console.log('Action complete:', args.requestType);
    
    if (args.requestType === 'viewNavigate' || args.requestType === 'dateNavigate' || 
        args.requestType === 'toolBarItemRendered' || args.requestType === 'initial') {
      
      this.currentDate = this.scheduleObj?.selectedDate ?? new Date(); // Keep local date synced
      this.currentView = this.scheduleObj?.currentView ?? 'Month'; // Keep local view synced
      console.log('Current view:', this.currentView);
      console.log('Current date:', this.currentDate);
      
      const displayView = this.scheduleObj?.activeViewOptions.displayName ?? '';
      
      // If switching to TimelineDay view, make sure resources are updated
      if (this.currentView === 'TimelineDay') {
        this.onResourceViewChange(displayView);
      }
      else {
        this.isTrainerView = false;
        localStorage.setItem('SELECTED_CAL_VIEW', this.currentView);
        this.updateGroupSettings();
      }
      this.loadDataForCurrentView();
    }
  }

  onResourceViewChange(displayName: string): void {
    if (displayName === 'Trainer View') {
      this.isTrainerView = true;
      localStorage.setItem('SELECTED_RES_VIEW', 'trainer');
      this.updateTrainerResources();
    }
    this.updateGroupSettings();
    // Force refresh events with the new resource settings
    setTimeout(() => {
      this.refreshEvents();
    }, 100);
  }

  onEventClick(args: EventClickArgs): void {
    args.cancel = true; // Prevent default Syncfusion popup/editor
    const eventData = args.event; // This is the clicked event data object
    this.openTaskPopup(eventData);
  }

  onCellDoubleClick(args: CellClickEventArgs): void {
    args.cancel = true; // Prevent default Syncfusion editor
    this.showTaskCreate = true;
    this.selectedDateTime = args.startTime;
  }

  onCellClick(args: CellClickEventArgs): void {
    args.cancel = true; // Prevent default Syncfusion editor
  }

  loadDataForCurrentView(): void {
    const view = this.scheduleObj?.getCurrentViewDates();
    
    // If view dates are available, use them
    if (view && view.length > 0) {
      this.calendarStartDate = this.datepipe.transform(view[0], 'yyyy-MM-dd');
      // For month view, the last date might be in the next month, adjust if needed
      let endDate = view[view.length - 1];
      if (this.currentView === 'Agenda') {
        // Agenda might span multiple days, use the last date provided
        endDate = view[view.length - 1];
      } else if (this.currentView === 'Day') {
        // For Day view, add 1 day to end date
        endDate = new Date(view[0]);
        endDate.setDate(endDate.getDate() + 1);
      } else {
        // For Week, Timeline views, the last date is usually correct
        endDate = view[view.length - 1];
      }
      this.calendarEndDate = this.datepipe.transform(endDate, 'yyyy-MM-dd');
    } 
    // Fallback for when view dates are not available (initial load, refresh)
    else {
      const currentDate = this.currentDate || new Date();
      
      // Create date range based on current view
      if (this.currentView === 'Day') {
        this.calendarStartDate = this.datepipe.transform(currentDate, 'yyyy-MM-dd');
        
        // For Day view, add 1 day to current date for end date
        const nextDay = new Date(currentDate);
        nextDay.setDate(nextDay.getDate() + 1);
        this.calendarEndDate = this.datepipe.transform(nextDay, 'yyyy-MM-dd');
      } 
      else if (this.currentView === 'Week' || this.currentView === 'WorkWeek') {
        // For week views, get first day of the week through last day
        const firstDayOfWeek = new Date(currentDate);
        const day = currentDate.getDay();
        const diff = currentDate.getDate() - day + (day === 0 ? -6 : 1); // Adjust for Sunday
        firstDayOfWeek.setDate(diff);
        
        const lastDayOfWeek = new Date(firstDayOfWeek);
        lastDayOfWeek.setDate(lastDayOfWeek.getDate() + 6);
        
        this.calendarStartDate = this.datepipe.transform(firstDayOfWeek, 'yyyy-MM-dd');
        this.calendarEndDate = this.datepipe.transform(lastDayOfWeek, 'yyyy-MM-dd');
      } 
      else if (this.currentView === 'Month') {
        // For month view, get first day of month through last day
        const firstDayOfMonth = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1);
        const lastDayOfMonth = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 0);
        
        // Include adjacent month days that may be visible in the month view
        const firstDay = new Date(firstDayOfMonth);
        const dayOfWeek = firstDay.getDay();
        firstDay.setDate(firstDay.getDate() - (dayOfWeek === 0 ? 7 : dayOfWeek) + 1);
        
        const lastDay = new Date(lastDayOfMonth);
        const lastDayOfWeekDay = lastDay.getDay();
        lastDay.setDate(lastDay.getDate() + (lastDayOfWeekDay === 0 ? 0 : 7 - lastDayOfWeekDay));
        
        this.calendarStartDate = this.datepipe.transform(firstDay, 'yyyy-MM-dd');
        this.calendarEndDate = this.datepipe.transform(lastDay, 'yyyy-MM-dd');
      } 
      else {
        // Default fallback - current month
        const firstDayOfMonth = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1);
        const lastDayOfMonth = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 0);
        
        this.calendarStartDate = this.datepipe.transform(firstDayOfMonth, 'yyyy-MM-dd');
        this.calendarEndDate = this.datepipe.transform(lastDayOfMonth, 'yyyy-MM-dd');
      }
    }
    
    // Now fetch data with the determined date range
    if (this.calendarStartDate && this.calendarEndDate) {
      this.getAllTask(this.calendarStartDate, this.calendarEndDate);
    }
  }

  updateTrainerResources(): void {
    this.trainerResources = [];
    this.getAccessedStaffList$.value.forEach((staff: any) => {
      if (this.selectedTrainer.has(staff.id) || this.selectedTrainer.size === 0) {
        this.resource = { id: staff.id, name: staff.name, img: staff.ff_picture, color: '' };
        this.trainerResources.push(this.resource);
      }
    });
  }

  refreshEvents(): void {
    const events = this.CreateEvents(this.allTasks.value);
    this.eventSettings = { ...this.eventSettings, dataSource: events };
    if (this.scheduleObj) {
      this.scheduleObj.eventSettings = this.eventSettings;
      this.scheduleObj.dataBind();
    }
  }

}

const routes: Routes = [
  {
    path: '',
    component: SalesCalendarComponent,
    canActivate: [AuthguardService],
    resolve: { data: TenantResolverService },
    data: {
      breadcrumb: 'Sales Calendar',
      title:"Sales Calendar"
    },
  },
]
